 import { Injectable } from '@angular/core';
import { IRacunFilterDto, PdvOpseg, TipRacuna, VrstaRacuna } from '@kodit/core/data-api';
import { AdvancedFilterActionData } from '@kodit/core/shared-ui';
import { BehaviorSubject, Observable } from 'rxjs';
 import { Store } from '@ngrx/store';
 import { clearFilter, setFilter } from '../state/filters/filter.actions';
 import { selectFilterByKey } from '../state/filters/filter.selectors';
 import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RacunFilterService {
  private _filterKey: string;
  filters: IRacunFilterDto;

  init(params: {
    vrstaRacuna?: VrstaRacuna;
    tipRacuna?: TipRacuna;
    jePravnoLice: boolean;
  }): void {
    const parts = ['racuni'];
    if (params.vrstaRacuna != null) {
      parts.push(VrstaRacuna[params.vrstaRacuna]);
    }
    if (params.tipRacuna != null) {
      parts.push(TipRacuna[params.tipRacuna]);
    }
    if (params.jePravnoLice) {
      parts.push('pravnaLica');
    }
    this._filterKey = parts.join('-');

    console.log('init filters: ', this._filterKey);
  }

  clear() {
    this._storage.dispatch(clearFilter({ key: this._filterKey }));
    console.log('clear filters: ', this._filterKey);
  }

  set(filters: IRacunFilterDto) {
    //filters.strankaId = this._strankaId;

    this._storage.dispatch(
      setFilter({
        key: this._filterKey,
        filter: JSON.stringify(filters),
      })
    );
    console.log('set filters: ', this._filterKey, ' -> ', filters);
  }

  get(): Observable<string> {
    return this._storage.select(selectFilterByKey(this._filterKey));
  }

  getByKey(key: string): Observable<string> {
    return this._storage.select(selectFilterByKey(key));
  }

  shouldDisableStrankeFilter$ = new BehaviorSubject<boolean>(false);

  setShouldDisableStrankeFilter(strankaId: number | undefined): void {
    this.shouldDisableStrankeFilter$.next(
      strankaId != undefined && strankaId > 0
    );
  }

  getShouldDisableStrankeFilter(): Observable<boolean> {
    return this.shouldDisableStrankeFilter$.asObservable();
  }

  constructor(private _storage: Store) {}

  /**
   * Advanced filter methods
   */
  advanceFilterSubmitted$ = new BehaviorSubject<
    AdvancedFilterActionData<IRacunFilterDto>
  >(null);
  get getAdvanceFilterSubmitted() {
    return this.advanceFilterSubmitted$.asObservable();
  }
  set setAdvanceFilterSubmitted(
    data: AdvancedFilterActionData<IRacunFilterDto>
  ) {
    this.advanceFilterSubmitted$.next(data);
  }

  /**Racun filter opseg set i get */

  private readonly vremenskiOpsegInit = null;
  vremenskiOpseg$ = new BehaviorSubject<PdvOpseg | null>(
    this.vremenskiOpsegInit
  );

  set setOpseg(value: PdvOpseg | null) {
    this.vremenskiOpseg$.next(value);
  }

  get getOpseg() {
    return this.vremenskiOpseg$.asObservable();
  }

  resetOpseg() {
    this.setOpseg = this.vremenskiOpsegInit;
  }
}
